import { Box } from '@mui/material'
import MUIDialogTitle from '@mui/material/DialogTitle'
import { AlertStyles as styles } from 'src/components/shared/ui/AlertDialog/AlertStyles'
import AlertIconTitle from 'src/components/shared/ui/AlertDialog/components/AlertIconTitle'
import AlertTitle from 'src/components/shared/ui/AlertDialog/components/AlertTitle'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'

interface DialogTitleProps {
  type: AlertType
  title?: string
  onClose?: () => void
}
export function AlertTitleDialog(props: DialogTitleProps): JSX.Element {
  const { title, type, ...other } = props

  return (
    <Box sx={styles(type).containerTitle}>
      <MUIDialogTitle {...other}>
        <AlertIconTitle type={type} />
        {title && <AlertTitle type={type} title={title} />}
        {/* {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={styles(type).closeButton}
            size="small"
          >
            <LfCloseIcon sx={styles(type).closeIcon} />
          </IconButton>
        ) : null} */}
      </MUIDialogTitle>
    </Box>
  )
}
